import type { QueryResult } from '@apollo/react-hooks';
import { useQuery, gql } from '@apollo/react-hooks';
import { getWorkOrderRelatedCounts } from '#/graphql/queries';
import type { GetWorkOrderRelatedCountsQuery } from '#/graphql/types';

export const GET_WORK_ORDER_RELATED_COUNTS = gql(getWorkOrderRelatedCounts);

const useWorkOrderRelatedCounts = (workOrderId: string) => {
  const { data, loading }: QueryResult<GetWorkOrderRelatedCountsQuery> = useQuery(
    GET_WORK_ORDER_RELATED_COUNTS,
    {
      variables: { workOrderId },
      fetchPolicy: 'cache-and-network',
    },
  );

  return { ...(data?.getWorkOrderRelatedCounts ?? {}), loading };
};

export default useWorkOrderRelatedCounts;
